import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Datetime from 'react-datetime';
import Moment from 'moment';
import { formatTimezoneDateTime } from 'helper/unit-helper';
import * as LotActionType from '../constants';
import { Dropdown } from '../../components/Dropdown/Dropdown';
import Input from 'components/react-validation/components/input';
import * as Vali from 'helper/validator-helper';
import Form from 'components/react-validation/components/form';
import Textarea from '../../components/react-validation/components/text-area';
import Submit from '../../components/react-validation/components/submit';
import * as ProjectActionType from 'Projects/constants';
import * as ModelActionType from 'Model/constants';
import * as InsuranceActionType from 'Insurance/constants';
import Translate from 'components/translate';

class EditLot extends Component {
  static propTypes = {
    match: PropTypes.object,
    dispatch: PropTypes.func,
    LotProfile: PropTypes.object,
    PhaseList: PropTypes.array,
    PlanList: PropTypes.array,
    onToggleViewMode: PropTypes.func,
    ErrorMsg: PropTypes.any,
    InsuranceList: PropTypes.array,
    ProjectList: PropTypes.array
  }

  constructor(props) {
    super(props);
    this.state = {
      phase: {
        value: props.LotProfile.phaseId,
        text: props.LotProfile.phaseName,
        extensionValue: null,
        selected: false
      },
      plan: {
        value: props.LotProfile.modelId,
        text: props.LotProfile.modelName,
        extensionValue: null,
        selected: false
      },
      projectCode: {
        value: props.LotProfile.projectCode,
        text: props.LotProfile.projectCode,
        extensionValue: null,
        selected: false
      },
      insurance: props.LotProfile.insurancePolicy ? {
        value: props.LotProfile.insurancePolicy.id,
        text: props.LotProfile.insurancePolicy.name,
        extensionValue: null,
        selected: false
      } : null,
      coe: props.LotProfile.coe,
      isFetchedPhase: false,
      isFetchedPlan: false,
      isLoadingPhase: false,
      isLoadingPlan: false,
      isLoadingProjectCode: false
    };
  }

  componentDidMount() {

    this.props.dispatch({
      type: LotActionType.GET_LIST_COST_CODE_ASYNC,
      params: {
        projectId: this.props.LotProfile.projectId
      }
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.PhaseList) {
      this.setState({
        isLoadingPhase: false
      });
    }

    if (nextProps.PlanList) {
      this.setState({
        isLoadingPlan: false
      });
    }

    if (nextProps.InsuranceList) {
      this.setState({
        isLoadingInsurance: false
      });
    }
    if (nextProps.ProjectList) {
      this.setState({
        isLoadingProjectCode: false
      });
    }

    if (nextProps.ErrorMsg.length) {
      this.setState({
        error: nextProps.ErrorMsg[0].error
      });
    }
  }

  onBindingLot = () => {
    this.props.dispatch({
      type: LotActionType.GET_LOT_BY_ID_ASYNC,
      params: this.state.lotId
    });
  }

  onSelectChange = (event, name) => {
    this.setState({
      [name]: event.value
    });
  }

  fetchPhase = () => {
    this.setState({ isLoadingPhase: true });
    this.props.dispatch({
      type: ProjectActionType.GET_LIST_PHASE_BY_PROJECT_ASYNC,
      params: {
        projectId: this.props.LotProfile.projectId,
        searchKey: '',
        selectedValue: ''
      },
      callback: () => {
        this.setState({ isFetchedPhase: true });
      }
    });
  }

  fetchPlan = () => {
    this.setState({ isLoadingPlan: true });
    this.props.dispatch({
      type: ModelActionType.GET_LIST_MODEL_BY_PROJECT_ASYNC,
      params: {
        projectId: this.props.LotProfile.projectId,
        searchKey: '',
        selectedValue: ''
      },
      callback: () => {
        this.setState({ isFetchedPlan: true });
      }
    });
  }

  fetchInsurance = () => {
    this.setState({ isLoadingInsurance: true });
    this.props.dispatch({
      type: InsuranceActionType.GET_SELECT_LIST_INSURANCE_POLICY_ASYNC,
      params: {
        searchKey: '',
        selectedValue: ''
      },
      callback: () => {
        this.setState({ isFetchedInsurance: true });
      }
    });
  }

  onToggleViewMode = () => {
    this.props.onToggleViewMode();
  }

  onSubmit = (e) => {
    e.preventDefault();
    const values = this.form.getValues();

    const {LotProfile} = this.props;

    const { phase, plan, insurance, coe, projectCode } = this.state;

    let params = {};
    params['id'] = LotProfile.id;
    params['name'] = values.lotNumber;
    params['phaseId'] = phase.value;
    params['modelId'] = plan.value;
    params['insurancePolicyId'] = insurance ? insurance.value : null;
    params['streetAddress'] = values.streetAddress;
    params['coe'] = coe ? formatTimezoneDateTime(Moment(coe)) : null;
    params['note'] = values.note;
    params['projectId'] = LotProfile.projectId;
    params['projectCode'] = projectCode.value;

    this.props.dispatch({
      type: LotActionType.UPDATE_LOT_ASYNC,
      params,
      callback: () => {
        this.onToggleViewMode();
      }
    });
  }

  renderLotInfoDetail = (data) => {
    if (data) {
      return <strong>{data}</strong>;
    }
    return <span style={{ 'opacity': '.5' }}>(Not specified)</span>;
  }

  renderLotCOE = (coe) => {
    if (coe) {
      return <strong>{Moment(coe).format('MM/DD/YYYY')}</strong>;
    }
    return <span style={{ 'opacity': '.5' }}>(Not specified)</span>;
  }

  render() {
    const { LotProfile } = this.props;
    let { name, streetAddress, note } = LotProfile;
    if (this.form) {
      name = this.form.getValues().lotNumber;
      streetAddress = this.form.getValues().streetAddress;
      note = this.form.getValues().note;
    }
    return (
      <div className='lot-info-content lot-info-detail'>
        <Form className='form-horizontal' ref={ref => { this.form = ref; }} onSubmit={this.onSubmit} style={{ paddingLeft: 15 }}>
          <div className='row'>
            <div className='form-group col-sm-12 col-md-12 col-lg-6'>
              <label className='lot-info-label'><Translate translateKey='project' plurals capitalize /></label>
              <span className='lot-info-value'>{this.renderLotInfoDetail(LotProfile.projectName)}</span>
            </div>
          </div>
          <div className='row'>
            <div className='form-group col-sm-12 col-md-12 col-lg-6'>
              <label className='lot-info-label'>Location</label>
              <span className='lot-info-value'>{this.renderLotInfoDetail(LotProfile.location)}</span>
            </div>
          </div>
          <div className='row'>
            <div className='form-group col-sm-12 col-md-12 col-lg-6'>
              <label className='col-sm-12'><Translate translateKey='phase' capitalize /> <span className='text-danger'>*</span></label>
              <div className='col-sm-12' style={{ paddingLeft: 15 }}>
                <Dropdown
                  onChange={ref => { this.onSelectChange(ref, 'phase'); }}
                  filter={true}
                  className='filestring-dropdown filter-dropdown'
                  onRemote={this.fetchPhase}
                  options={this.state.isFetchedPhase ? this.props.PhaseList : [{ ...this.state.phase }]}
                  optionLabel='text'
                  value={this.state.phase}
                  loading={this.state.isLoadingPhase}
                  name='phase'
                  placeholder='-- Please select'
                  style={{ width: '100%', marginBottom: 0 }} />
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='form-group col-sm-12 col-md-12 col-lg-6'>
              <label className='col-sm-12'>Plan <span className='text-danger'>*</span></label>
              <div className='col-sm-12' style={{ paddingLeft: 15 }}>
                <Dropdown
                  onChange={ref => { this.onSelectChange(ref, 'plan'); }}
                  filter={true}
                  className='filestring-dropdown filter-dropdown'
                  onRemote={this.fetchPlan}
                  options={this.state.isFetchedPlan ? this.props.PlanList : [{ ...this.state.plan }]}
                  optionLabel='text'
                  value={this.state.plan}
                  loading={this.state.isLoadingPlan}
                  name='plan'
                  placeholder='-- Please select'
                  style={{ width: '100%', marginBottom: 0 }} />
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='form-group col-sm-12 col-md-12 col-lg-6'>
              <label className='col-sm-12'>Cost center/account <span className='text-danger' /></label>
              <div className='col-sm-12' style={{ paddingLeft: 15 }}>
                <Dropdown
                  onChange={ref => { this.onSelectChange(ref, 'projectCode'); }}
                  filter={true}
                  className='filestring-dropdown filter-dropdown'
                  // onRemote={this.fetchProjectCostCode}
                  options={this.props.ProjectList}
                  optionLabel='text'
                  value={this.state.projectCode}
                  // loading={this.state.isLoadingProjectCode}
                  name='projectCode'
                  placeholder='-- Please select'
                  style={{ width: '100%', marginBottom: 0 }} />
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='form-group col-sm-12 col-md-12 col-lg-6'>
              <label className='col-sm-12'>Insurance policy</label>
              <div className='col-sm-12' style={{ paddingLeft: 15 }}>
                <Dropdown
                  onChange={ref => { this.onSelectChange(ref, 'insurance'); }}
                  filter={true}
                  className='filestring-dropdown filter-dropdown'
                  onRemote={this.fetchInsurance}
                  options={this.state.isFetchedInsurance ? this.props.InsuranceList : [{ ...this.state.insurance }]}
                  optionLabel='text'
                  value={this.state.insurance}
                  loading={this.state.isLoadingInsurance}
                  name='insurance'
                  placeholder='-- Please select'
                  showClear={true}
                  style={{ width: '100%', marginBottom: 0 }} />
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='form-group col-sm-12 col-md-12 col-lg-6'>
              <label className='col-sm-12'><Translate translateKey='lot' capitalize /> number <span className='text-danger'>*</span></label>
              <div className='col-sm-12' style={{ paddingLeft: 15 }}>
                <Input
                  type='text'
                  name='lotNumber'
                  ref='lotNumber'
                  className='form-control'
                  value={name}
                  max='100'
                  maxLength='100'
                  validations={[Vali.required, Vali.maxlength]} />
                {this.state.error &&
                    <span className='text-danger' style={{display: 'block'}}>{this.state.error}</span>
                }
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='form-group col-sm-12 col-md-12 col-lg-6'>
              <label className='col-sm-12'>Street address <span className='text-danger'>*</span></label>
              <span className='col-sm-12' style={{ paddingLeft: 15 }}>
                <Input
                  type='text'
                  name='streetAddress'
                  ref='streetAddress'
                  className='form-control'
                  value={streetAddress}
                  max='200'
                  maxLength='200'
                  validations={[Vali.required, Vali.maxlength]} />
              </span>
            </div>
          </div>
          <div className='row'>
            <div className='form-group col-sm-12 col-md-12 col-lg-6'>
              <label className='col-sm-12'>Original COE</label>
              <span className='col-sm-12' style={{ paddingLeft: 15 }}>
                <Datetime
                  ref={ref => { this.coe = ref; }}
                  name='coe'
                  inputProps={{ placeholder: 'mm/dd/yyyy' }}
                  timeFormat={false}
                  defaultValue={Moment(LotProfile.coe)}
                  onChange={(coe) => {
                    if (Moment(coe, 'MM/DD/YYYY', true).isValid() || coe === '') {
                      this.setState({coe, dateError: null});
                    } else {
                      this.setState({dateError: 'Invalid datetime.'});
                    }
                  }} 
                  closeOnSelect={true}/>
                {this.state.dateError && <span className='text-danger' style={{fontSize: 12, marginTop: 5}}>{this.state.dateError}</span>}
              </span>
            </div>
          </div>
          <div className='row'>
            <div className='form-group col-sm-12 col-md-12 col-lg-6'>
              <label className='col-sm-12'>Note</label>
              <span className='col-sm-12' style={{ paddingLeft: 15 }}>
                <Textarea
                  name='note'
                  ref='note'
                  className='form-control'
                  value={note}
                  max='200'
                  maxLength='200'
                  style={{ height: 100 }}
                  validations={[Vali.maxlength]} />
              </span>
            </div>
          </div>
          <div className='row'>
            <div className='form-group col-sm-6' style={{ paddingLeft: 30 }}>
              <a
                className='btn btn-primary btn-siteone-default'
                onClick={this.onToggleViewMode}>Cancel</a>
              <Submit className='btn btn-primary btn-info btn-siteone' disabled={this.state.dateError}>Save</Submit>
            </div>
          </div>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    ErrorMsg: state.LotStore.ErrorMsg,
    PhaseList: state.PhaseStore.SelectListPhase,
    PlanList: state.ModelStore.SelectListPlan,
    InsuranceList: state.InsurancePolicyStore.SelectListInsurancePolicy,
    ProjectList: state.LotStore.SelectListCostCodes
  };
};

export default connect(mapStateToProps)(EditLot);



// WEBPACK FOOTER //
// ./src/Lots/Containers/lot-edit.js